import ContactState, {
    CustomerState,
    DPACheck,
    DPAResult,
    ICallContactAttributes,
    CTR,
    IOriginalContactState,
} from './contact.state';
import ContactTypes from './contact.types';
import { objectToContactAttibutes } from './contact.utils';
import { getContact as APIGetContact, postParkContact } from 'services/api/api.contact';
import AnyAction from 'store/anyActions';
import { ThunkDispatch } from 'redux-thunk';
import RootState from 'store/state';

interface ContactUpdated {
    ID: string;
    attributes: ICallContactAttributes;
    commitUpdate?: boolean;
}

export type ContactAction =
    | { type: typeof ContactTypes.UPDATE_CONTACT_ATTRIBUTES; payload: ContactUpdated }
    | { type: typeof ContactTypes.REMOVE_CONTACT_ATTRIBUTES; payload: ContactUpdated }
    | { type: typeof ContactTypes.SET_CONTACT; payload: ContactState | null }
    | { type: typeof ContactTypes.CLEAR_CONTACT }
    | { type: typeof ContactTypes.CUSTOMER_UPDATED; payload: Partial<CustomerState> }
    | { type: typeof ContactTypes.UPDATE_DPA_RESULT; payload: DPAResult }
    | { type: typeof ContactTypes.UPDATE_AGENT_DPA; payload: DPACheck }
    | { type: typeof ContactTypes.UPDATE_DPA; payload: Partial<DPACheck> }
    | { type: typeof ContactTypes.UPDATE_CONTACT; payload: ContactState }
    | { type: typeof ContactTypes.GET_CONTACT; payload: CTR }
    | { type: typeof ContactTypes.PARK_CALL_CONTACT; payload: number }
    | {
          type: typeof ContactTypes.UPDATE_ACW_ATTRIBUTES;
          payload: { acwAttributes: ICallContactAttributes; ID: string };
      };

export function parkCallContact(initialContactId?: string) {
    return async (dispatch: ThunkDispatch<RootState, undefined, ContactAction>, getState: () => RootState) => {
        const state = getState();

        if (!state.contact) {
            throw Error('Couldnt find contact');
        }

        try {
            const response = await postParkContact(
                initialContactId || state.contact.ID,
                state.app.ID,
                state.app.instance!.ID,
                state.auth.token!
            );

            if (response.status === 200) {
                dispatch({
                    type: ContactTypes.PARK_CALL_CONTACT,
                    payload: response.data.ParkBay!,
                });
            }
        } catch (error) {
            console.log(error);
        }
    };
}

export function removeContactAttributes(ID: string, attributes: string[]): ContactAction {
    return {
        type: ContactTypes.REMOVE_CONTACT_ATTRIBUTES,
        payload: {
            ID,
            attributes: objectToContactAttibutes(attributes),
        },
    };
}

export function updateContactAttributes(
    ID: string,
    attributes: Partial<ICallContactAttributes>,
    commitUpdate?: boolean
): ContactAction {
    return {
        type: ContactTypes.UPDATE_CONTACT_ATTRIBUTES,
        payload: {
            ID,
            attributes: objectToContactAttibutes(attributes),
            commitUpdate,
        },
    };
}

export function updateCustomer(customer: Partial<CustomerState>): ContactAction {
    return {
        type: ContactTypes.CUSTOMER_UPDATED,
        payload: customer,
    };
}

export function clearContact(): ContactAction {
    return {
        type: ContactTypes.CLEAR_CONTACT,
    };
}

export function setContact(contact: ContactState | null): ContactAction {
    return {
        type: ContactTypes.SET_CONTACT,
        payload: contact,
    };
}

export function updateDPAResult(payload: DPAResult): ContactAction {
    return {
        type: ContactTypes.UPDATE_DPA_RESULT,
        payload,
    };
}

export function updateAgentDPAResult(payload: DPACheck): ContactAction {
    return {
        type: ContactTypes.UPDATE_AGENT_DPA,
        payload,
    };
}

export function updateDPA(payload: DPACheck): ContactAction {
    return {
        type: ContactTypes.UPDATE_DPA,
        payload,
    };
}

export function updateContact(payload: ContactState) {
    return {
        type: ContactTypes.UPDATE_CONTACT,
        payload,
    };
}

export function getContact(contactID: string) {
    return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>, getState: () => RootState) => {
        try {
            const { contact } = getState();
            const response = await APIGetContact(contactID);

            dispatch({
                type: ContactTypes.GET_CONTACT,
                payload: response,
            });
            //Is this contact still selected?
            if (contact?.ID !== response.ID) return;

            dispatch({
                type: ContactTypes.SET_CONTACT,
                payload: response,
            });
        } catch (error) {
            console.log(error);
        }
    };
}

export function updateACWAttributes(ID: string, acwAttributes: ICallContactAttributes) {
    return {
        type: ContactTypes.UPDATE_ACW_ATTRIBUTES,
        payload: { acwAttributes, ID },
    };
}
